import "./App.css";
import CardPage from "./Components/CardPage/CardPage";

function App() {
  return (
    <div className="App">
      <CardPage />
    </div>
  );
}

export default App;
